import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import { downloadFile, getExportErrorMessage } from "../../helpers/exportFile";
const reportsApi = factory.get("reports");
const initialState = {
  reports: {
    loading: false,
  },
  repDetails: {
    loading: false,
    data: [],
    total: 0,
  },
  orders: {
    loading: false,
    data: [],
    total: 0,
  },
  soldPins: {
    loading: false,
    data: [],
    total: 0,
  },
  totalRevenue: {
    loading: false,
    data: {},
    total: 0,
  },
  cash: {
    loading: false,
    data: [],
    total: 0,
    cash: 0,
  },
  totals: {},
  stock: {
    data: [],
    total: 0,
  },
  ordersDetailed: {
    data: [],
    total: 0,
  },
  posOrders: {
    data: [],
    total: 0,
  },
  ordersPinsDetails: {
    data: [],
    total: 0,
  },
  platformPayments: {
    data: [],
    total: 0,
    total_amount: 0,
  },
  posOrdersPerWeek: {
    loading: false,
    data: [],
    total: 0,
    rep_id: null,
  },
  repOrdersPerWeek: {
    loading: false,
    data: [],
    total: 0,
  },
  teamLeaderOrdersPerDays: {
    loading: false,
    data: [],
    total: 0,
  },
  posEPayments: {
    loading: false,
    data: [],
    total: 0,
  },
  lazyPos: {
    loading: false,
    data: [],
    total: 0,
  },
  repPosEPayments: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setRepDetailsDataTable: (state, { payload }) => {
      state.repDetails.data = payload.data.data;
      state.repDetails.total = payload.data.total;
    },
    setOrdersTable: (state, { payload }) => {
      state.orders.data = payload.data.data;
      state.orders.total = payload.data.total;
    },
    setSoldPinsTable: (state, { payload }) => {
      state.soldPins.data = payload.data.data;
      state.soldPins.total = payload.data.total;
    },
    setTotalRevenueTable: (state, { payload }) => {
      state.totalRevenue.data = payload.data.data;
    },
    setCashTable: (state, { payload }) => {
      state.cash.data = payload.data.data.data;
      state.cash.total = payload.data.total;
      state.cash.cash = payload.data.data.cash;
    },
    setTotalsTable: (state, { payload }) => {
      state.totals = payload.data.data;
    },
    setStockTable: (state, { payload }) => {
      state.stock.data = payload.data.data;
      state.stock.total = payload.data.total;
    },
    setOrderDetailedTable: (state, { payload }) => {
      state.ordersDetailed.data = payload.data.data;
      state.ordersDetailed.total = payload.data.total;
    },
    setPosOrdersTable: (state, { payload }) => {
      state.posOrders.data = payload.data.data;
      state.posOrders.total = payload.data.total;
    },
    setOrdersPinsDetailsTable: (state, { payload }) => {
      state.ordersPinsDetails.data = payload.data.data;
      state.ordersPinsDetails.total = payload.data.total;
    },
    setPlatformPaymentsTable: (state, { payload }) => {
      state.platformPayments.data = payload.data.data;
      state.platformPayments.total = payload.data.total;
      state.platformPayments.total_amount = payload.data.total_amount;
    },
    setPosOrdersPerWeekTable: (state, { payload }) => {
      state.posOrdersPerWeek.data = payload.data.data;
      state.posOrdersPerWeek.total = payload.data.total;
    },
    setRepOrdersPerWeekTable: (state, { payload }) => {
      state.repOrdersPerWeek.data = payload.data.data;
      state.repOrdersPerWeek.total = payload.data.total;
    },
    setTeamLeaderOrdersPerDaysTable: (state, { payload }) => {
      state.teamLeaderOrdersPerDays.data = payload.data.data;
      state.teamLeaderOrdersPerDays.total = payload.data.total;
    },
    setPosEPaymentsTable: (state, { payload }) => {
      state.posEPayments.data = payload.data.data;
      state.posEPayments.total = payload.data.total;
    },
    setLazyPosTable: (state, { payload }) => {
      state.lazyPos.data = payload.data.data;
      state.lazyPos.total = payload.data.total;
    },
    setRepPosEPaymentsTable: (state, { payload }) => {
      state.repPosEPayments.data = payload.data.data;
      state.repPosEPayments.total = payload.data.total;
    },
    setRepId: (state, { payload }) => {
      state.posOrdersPerWeek.rep_id = payload;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
  },
});

export const {
  setLoading,
  setRepDetailsDataTable,
  setOrdersTable,
  setSoldPinsTable,
  setTotalRevenueTable,
  setCashTable,
  setTotalsTable,
  setStockTable,
  setOrderDetailedTable,
  setPosOrdersTable,
  setOrdersPinsDetailsTable,
  setPlatformPaymentsTable,
  setPosOrdersPerWeekTable,
  setRepOrdersPerWeekTable,
  setPosEPaymentsTable,
  setLazyPosTable,
  setRepPosEPaymentsTable,
  setRepId,
  setTeamLeaderOrdersPerDaysTable,
} = reportsSlice.actions;

export default reportsSlice.reducer;

//axios
const getAll = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.getAllRep(data);
    dispatch(setRepDetailsDataTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getOrders = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.orders(data);
    dispatch(setOrdersTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getSoldPins = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.soldPins(data);
    dispatch(setSoldPinsTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const totalRevenue = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.totalRevenue(data);
    dispatch(setTotalRevenueTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const cash = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.cash(data);
    dispatch(setCashTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const totals = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.totals(data);
    dispatch(setTotalsTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const stock = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.stock(data);
    dispatch(setStockTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getOrdersDetailed = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.ordersDetailed(data);
    dispatch(setOrderDetailedTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getordersPinsDetails = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.ordersPinsDetails(data);
    dispatch(setOrdersPinsDetailsTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getPosOrders = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.posOrders(data);
    dispatch(setPosOrdersTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getPlatformPayments = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.platformPayments(data);
    dispatch(setPlatformPaymentsTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getPosOrdersPerWeek = () => async (dispatch) => {
  try {
    dispatch(setLoading("posOrdersPerWeek"));
    const res = await reportsApi.posOrdersPerWeek();
    dispatch(setPosOrdersPerWeekTable(res));
    dispatch(setLoading("posOrdersPerWeek"));
  } catch (err) {
    dispatch(setLoading("posOrdersPerWeek"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getRepOrdersPerWeek = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("repOrdersPerWeek"));
    const res = await reportsApi.repOrdersPerWeek(data);
    dispatch(setRepOrdersPerWeekTable(res));
    dispatch(setLoading("repOrdersPerWeek"));
  } catch (err) {
    dispatch(setLoading("repOrdersPerWeek"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getTeamLeaderOrdersPerDays = () => async (dispatch) => {
  try {
    dispatch(setLoading("teamLeaderOrdersPerDays"));
    const res = await reportsApi.teamLeaderOrdersPerDays();
    dispatch(setTeamLeaderOrdersPerDaysTable(res));
    dispatch(setLoading("teamLeaderOrdersPerDays"));
  } catch (err) {
    dispatch(setLoading("teamLeaderOrdersPerDays"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getPosEPayments = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.posEPayments(data);
    dispatch(setPosEPaymentsTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const exportPosEPayments = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.posEPaymentsExport({
      ...data,
      is_excel: 1,
    });
    await downloadFile(res, `pos-e-payments-report.xlsx`);
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: await getExportErrorMessage(err),
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getLazyPos = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.lazyPos(data);
    dispatch(setLazyPosTable(res));
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const exportLazyPos = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("reports"));
    const res = await reportsApi.lazyPosExport({
      ...data,
      is_excel: 1,
    });
    await downloadFile(res, `lazy-pos-report.xlsx`);
    dispatch(setLoading("reports"));
  } catch (err) {
    dispatch(setLoading("reports"));
    dispatch(
      showNotification({
        message: await getExportErrorMessage(err),
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getRepPosEPayments = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("repPosEPayments"));
    const res = await reportsApi.repPosEPayments(data);
    dispatch(setRepPosEPaymentsTable(res));
    dispatch(setLoading("repPosEPayments"));
  } catch (err) {
    dispatch(setLoading("repPosEPayments"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const exportRepPosEPayments = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("repPosEPayments"));
    const res = await reportsApi.repPosEPaymentsExport({
      ...data,
      is_excel: 1,
    });
    await downloadFile(res, `rep-pos-e-payments-report.xlsx`);
    dispatch(setLoading("repPosEPayments"));
  } catch (err) {
    dispatch(setLoading("repPosEPayments"));
    dispatch(
      showNotification({
        message: await getExportErrorMessage(err),
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Reports = {
  getAll,
  getOrders,
  getSoldPins,
  totalRevenue,
  cash,
  totals,
  stock,
  getOrdersDetailed,
  getPosOrders,
  getordersPinsDetails,
  getPlatformPayments,
  getPosOrdersPerWeek,
  getRepOrdersPerWeek,
  getTeamLeaderOrdersPerDays,
  getPosEPayments,
  exportPosEPayments,
  getLazyPos,
  exportLazyPos,
  getRepPosEPayments,
  exportRepPosEPayments,
};
